module.exports = __webpack_public_path__ + "lato-black-webfont.2e1139184b7509c3dd80.woff";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-black-webfont.woff
// module id = ../../../../../resources/fonts/lato-black-webfont.woff
// module chunks = styles